import styled from 'styled-components';

export const Container = styled.div<{ error?: boolean }>`
  display: inline-flex;
  width: 50%;
  min-width: 200px;
  align-items: start;
  flex-direction: column;
  position: relative;

  .dimension-value-input {
    width: 100% !important;

    .ant-select-selection-overflow {
      overflow: auto;
      max-height: 155px;
    }
  }
`;
